@if (forms.state(); as s) {
  <app-anchored-popup
    placement="bottom-start"
    [anchorEl]="s.anchorEl"
    [width]="304"
    [owner]="forms"
    (dismiss)="dismiss()">
    @if (s.data.kind === 'set-time' || s.data.kind === 'route-start') {
      <app-set-time-form [request]="s.data" (done)="forms.close()" />
    } @else if (s.data.kind === 'move-to') {
      <app-move-to-form [request]="s.data" (done)="forms.close()" />
    } @else if (s.data.kind === 'resources') {
      <app-route-resources-form [routeUid]="s.data.routeUid" (done)="forms.close()" />
    } @else if (s.data.kind === 'new-route') {
      <app-route-resources-form
        [routeUid]="null"
        [then]="s.data.then"
        [carriedName]="s.data.carriedName ?? null"
        (done)="forms.close()" />
    } @else if (s.data.kind === 'swap') {
      <app-swap-resources-form
        [routeUid]="s.data.routeUid"
        [otherRouteUid]="s.data.otherRouteUid"
        (done)="forms.close()" />
    }
  </app-anchored-popup>
}
